var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_177_51681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.20705 11.9798C7.59235 11.9798 6.29529 10.6827 6.29529 9.06801C6.29529 7.45331 7.59235 6.15625 9.20705 6.15625C10.8218 6.15625 12.1188 7.45331 12.1188 9.06801C12.1188 10.6827 10.8218 11.9798 9.20705 11.9798ZM9.20705 7.47978C8.33352 7.47978 7.61882 8.19449 7.61882 9.06801C7.61882 9.94154 8.33352 10.6562 9.20705 10.6562C10.0806 10.6562 10.7953 9.94154 10.7953 9.06801C10.7953 8.19449 10.0806 7.47978 9.20705 7.47978Z",
    fill: "#A461D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20704 17.5916C8.65115 17.5916 8.09527 17.3798 7.67174 16.9563L4.49527 13.7798C1.90115 11.1857 1.90115 6.9504 4.49527 4.35628C5.76586 3.0857 7.43351 2.39746 9.20704 2.39746C10.9806 2.39746 12.6482 3.0857 13.9188 4.35628C16.5129 6.9504 16.5129 11.1857 13.9188 13.7798L10.7423 16.9563C10.3188 17.3798 9.76292 17.5916 9.20704 17.5916ZM9.20704 3.72099C7.83056 3.72099 6.48056 4.2504 5.42174 5.28275C3.33056 7.37393 3.33056 10.7622 5.42174 12.8269L8.59821 16.0033C8.91586 16.321 9.44527 16.321 9.78939 16.0033L12.9659 12.8269C15.057 10.7357 15.057 7.34746 12.9659 5.28275C11.9335 4.2504 10.5835 3.72099 9.20704 3.72099Z",
    fill: "#A461D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_177_51681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.207031 0.80957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPurple);
export default __webpack_public_path__ + "static/media/Location-purple.137a3e630ebd51c16f716d777423479b.svg";
export { ForwardRef as ReactComponent };